import { z } from 'zod';

export const TrackingSchema = z.object({
    device: z
        .object({
            uniqueId: z.string().min(1, { message: 'Required' }),
            enabled: z.boolean({ message: 'Required' }),
        })
        .optional()
        .nullable(),
});
